'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-webpack-spinner/~/react/react.js
 ** module id = 945
 ** module chunks = 0
 **/